export default "__VITE_ASSET__86ef79ca__"